import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Box, Flex, VStack } from '@televet/kibble-ui/chakra';
import { Heading } from '@televet/kibble-ui/Heading';
import { Text } from '@televet/kibble-ui/Text';

/**
 * Dev route layout for pet-web.
 * Houses fixture-based routes for testing forms submission flow.
 */
function DevLayout(): React.JSX.Element {
  const isEnabled = import.meta.env.VITE_FORMS_FIXTURE_ENABLED === 'true';

  if (!isEnabled) {
    return (
      <Flex justify="center" align="center" minH="100vh" p={8}>
        <VStack gap={4}>
          <Heading size="md">Dev Routes Disabled</Heading>
          <Text color="text.subtle">Set VITE_FORMS_FIXTURE_ENABLED=true to enable dev routes.</Text>
        </VStack>
      </Flex>
    );
  }

  return (
    <Box p={4}>
      <Outlet />
    </Box>
  );
}

export const Route = createFileRoute('/dev')({
  component: DevLayout,
});
